export default "__VITE_ASSET__BP1KKXR1__"